export default __webpack_public_path__ + "static/media/20.c23b2514.jpg";